import React from 'react'
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceLine } from 'recharts'
// @ts-expect-error
import { DefaultTooltipContent } from 'recharts/lib/component/DefaultTooltipContent'
import { useResultsContext } from '../context/context'

const CustomTooltip = (ordering: 'highest' | 'lowest') => (props: any) => {
  // we don't need to check payload[0] as there's a better prop for this purpose
  if (!props.active) {
    // I think returning null works based on this: http://recharts.org/en-US/examples/CustomContentOfTooltip
    return null
  }
  // mutating props directly is against react's conventions
  // so we create a new payload with the name and value fields set to what we want
  const newPayload = [
    ...props.payload.sort((a: any, b: any) => {
      if (ordering === 'highest') {
        return b.value - a.value
      } else {
        return a.value - b.value
      }
    }),
  ]

  // we render the default, but with our overridden payload
  return <DefaultTooltipContent {...props} payload={newPayload} />
}

interface LineData {
  name: string
  key: string
  colour: string
}

interface Props {
  data: object[]
  formatter?: (val: number) => string | number
  yAxisFormatter?: (val: number) => string | number
  maxYAxisvalue: number
  minYAxisvalue: number
  numberOfTicks: number
  lines: LineData[]
  tooltipOrdering?: 'highest' | 'lowest'
}

const ResultsLineChart: React.FC<Props> = ({ data, lines, formatter, yAxisFormatter, maxYAxisvalue, minYAxisvalue, numberOfTicks, tooltipOrdering = 'highest' }) => {

  const context = useResultsContext()

  return (
    <>
      <ResponsiveContainer width='100%' height='100%' debounce={1}>
        <LineChart
          data={data}
          margin={{
            top: 20,
            right: 50,
            bottom: 10,
          }}
        >
          <CartesianGrid vertical={false} />
          <ReferenceLine y={0} stroke='#000' />
          <XAxis dataKey='name' tickLine={false} padding={{ left: 75, right: 75 }} />
          <YAxis axisLine={false} tickLine={false} minTickGap={0} tickMargin={0} tickCount={numberOfTicks + 1} tickFormatter={yAxisFormatter ? (tick: any) => yAxisFormatter(tick) : formatter ? (tick) => formatter(tick) : (tick) => tick} domain={[minYAxisvalue, maxYAxisvalue]} />
          {/* // @ts-expect-error */}
          <Tooltip formatter={formatter ? (tick: any) => formatter(tick) : (tick: any) => tick} content={CustomTooltip(tooltipOrdering)} />
          {!context.hideTeamPositions && <Legend wrapperStyle={{ bottom: 10, left: 0, right: 0 }} />}
          {lines.map((l, idx) => (
            <Line key={`line-item-${idx}`} name={l.name} type='natural' dataKey={l.key} stroke={l.colour} strokeWidth={2} animationDuration={context.noAnimations ? 0 : 1000} animationBegin={context.noAnimations ? 0 : idx * 1000} />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </>
  )
}

export default ResultsLineChart
